import React, { useEffect } from 'react'
import './App.scss'
import 'styles/main.scss'
import Router from 'router'
import { getNetwork as getNetworkService } from 'services/admin'
import { useDispatch } from 'react-redux'
import { setNetworks } from 'store/network/networkSlice'

function App() {
  const dispatch = useDispatch()

  async function loadNetwork() {
    const rest = await getNetworkService()
    dispatch(setNetworks(rest || []))
  }

  useEffect(() => {
    loadNetwork()
  }, [])

  return <Router />
}

export default App
